import React from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { SidePanelRowProps } from 'components/SidePanel/SidePanelRow'
import { SidePanelSummary } from 'components/SidePanel/SidePanelSummary'
import { DateFormat } from 'constants/General'
import { Business } from 'types/customers'

export interface BusinessCustomerProps {
  company: Business
}

export const BusinessCustomer = ({ company }: BusinessCustomerProps) => {
  const { t } = useTranslation()
  const { address, representative } = company || {}

  const addressArray = [
    address?.addressLine1,
    ...(address?.addressLine2 ? [address?.addressLine2] : []),
    address?.city,
    address?.postalCode,
  ]

  const customerDetailsRows: SidePanelRowProps[] = [
    { label: t('type'), content: t(`embeddedCustomers.type.business`) },
    { label: t('businessName'), content: company?.name },
    { label: t('industry'), content: company?.industry?.name },
    { label: t('businessRegistrationNumber'), content: company?.registrationNumber },
    { label: t('taxResidencyCountry'), content: company?.taxResidenceCountryCode },
    { label: t('address'), content: addressArray?.length ? addressArray?.join(', ') : '' },
    { label: t('country'), content: address?.country },
  ]

  const representativeRows: SidePanelRowProps[] = [
    {
      label: t('representative.name'),
      content: `${representative?.firstName ?? ''} ${representative?.lastName ?? ''}`,
    },
    {
      label: t('representative.dateOfBirth'),
      content:
        !!representative?.dateOfBirth &&
        dayjs(representative?.dateOfBirth)?.format(DateFormat.DD_MM_YYYY_),
    },
    { label: t('representative.nationality'), content: representative?.address?.country },
  ]

  return (
    <>
      <SidePanelSummary
        heading={t('embeddedCustomers.details.customerDetails')}
        rows={customerDetailsRows}
      />
      <SidePanelSummary heading={t('representative.title')} rows={representativeRows} />
    </>
  )
}
